import {
  AssetAggregateDto,
  Country,
  QuestionTemplate,
  ReferenceApi,
} from 'services/generated';
import { rootApi } from 'store/root-api';
import api from 'services/api';
import { handleErrors } from 'services/helpers';

const referencesClient = new ReferenceApi(undefined, undefined, api);

export const referencesApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getCountries: builder.query<Country[], void>({
      queryFn: () => handleErrors(() => referencesClient.listCountries()),
      providesTags: [{ type: 'Countries', id: 'LIST' }],
    }),
    getAssets: builder.query<AssetAggregateDto[], void>({
      queryFn: () => handleErrors(() => referencesClient.listAssets()),
      providesTags: [{ type: 'Assets', id: 'LIST' }],
    }),
    getQuestionTemplates: builder.query<
      QuestionTemplate[],
      { type: 'Explore' | 'Portfolio' | 'Assets'; assetType?: string }
    >({
      queryFn: request =>
        handleErrors(() =>
          referencesClient.listQuestionTemplates(
            request.type,
            request.assetType,
          ),
        ),
      providesTags: (result, error, request) => [
        {
          type: 'AiQuestions',
          id: `${request.type}-${request.assetType ?? ''}`,
        },
      ],
    }),
  }),
});

export const {
  useGetCountriesQuery,
  useGetAssetsQuery,
  useGetQuestionTemplatesQuery,
} = referencesApi;
